import React, { useEffect, useState } from 'react';
interface StickyButtonProps {
  openModal: () => void;
}
export const StickyButton: React.FC<StickyButtonProps> = ({
  openModal
}) => {
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    // Format current date as "13 nov"
    const formatDate = () => {
      const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
      const now = new Date();
      const day = now.getDate();
      const month = months[now.getMonth()];
      return `${day} ${month}`;
    };
    setCurrentDate(formatDate());
  }, []);
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-lg border-t border-gray-200" data-id="element-288">
      <div className="max-w-3xl mx-auto px-4 py-3" data-id="element-289">
        <div className="text-center mb-2" data-id="element-290">
          <p className="text-sm text-gray-600" data-id="element-291">
            Vandaag {currentDate} • 10:00, 13:00 of 20:00
          </p>
        </div>
        <button onClick={openModal} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg transition duration-200 text-center" data-id="element-292">
          Gratis Webinar: Communiceren Met Je Hond (zonder domineren)
        </button>
      </div>
    </div>;
};